import React from 'react';
import { Main } from './components';

const PayoutView = () => <Main />;

export default PayoutView;
